var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBoomAiIcon = function SvgBoomAiIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "boomAI_icon_svg2__a",
    x1: 48.31,
    x2: 113.8,
    y1: 104.34,
    y2: 34.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#boomAI_icon_svg2__a",
    id: "boomAI_icon_svg2__b",
    x1: 13.77,
    x2: 79.26,
    y1: 72.08,
    y2: 1.96
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#boomAI_icon_svg2__a",
    id: "boomAI_icon_svg2__c",
    x1: 24.93,
    x2: 90.42,
    y1: 82.5,
    y2: 12.38
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#boomAI_icon_svg2__a",
    id: "boomAI_icon_svg2__d",
    x1: 46.56,
    x2: 112.06,
    y1: 102.71,
    y2: 32.58
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#boomAI_icon_svg2__a",
    id: "boomAI_icon_svg2__e",
    x1: 11.94,
    x2: 77.43,
    y1: 70.37,
    y2: 0.25
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#boomAI_icon_svg2__a",
    id: "boomAI_icon_svg2__f",
    x1: 6.44,
    x2: 71.93,
    y1: 65.23,
    y2: -4.89
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#boomAI_icon_svg2__a",
    id: "boomAI_icon_svg2__g",
    x1: 21.7,
    x2: 87.19,
    y1: 79.49,
    y2: 9.36
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m96.14 76.02-9.81-3.86a13.64 13.64 0 0 1-7.67-7.67l-3.86-9.74c-.11-.28-.33-.5-.61-.61-.56-.22-1.18.05-1.4.61l-3.86 9.74a13.59 13.59 0 0 1-7.67 7.67l-9.74 3.86c-.28.11-.5.33-.61.61-.22.56.05 1.18.61 1.4l9.74 3.86c3.51 1.38 6.29 4.16 7.67 7.67l3.86 9.74c.11.28.33.5.61.61.56.22 1.18-.05 1.4-.61l3.86-9.74c1.39-3.51 4.17-6.29 7.67-7.67l9.81-3.86c.28-.11.5-.33.61-.61.22-.56-.05-1.18-.61-1.4",
    style: {
      fill: "url(#boomAI_icon_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.07 52.47c4.89-3.15 7.36-8.87 6.33-14.67-.96-5.4-5.28-9.94-10.61-11.09-6.59-1.43-11.62 1.32-15.21 5.57-.22.26-.3.92-.13 1.19.9 1.45 1.89 2.83 2.5 3.71 1.5-1.24 2.87-2.49 4.35-3.58 3.75-2.77 9.15-2.04 11.94 1.55 2.8 3.59 2.28 8.86-1.17 11.86s-8.57 2.97-11.86-.55c-2.45-2.63-4.28-5.82-6.44-8.73-1.74-2.36-3.39-4.81-5.37-6.96-2.6-2.81-5.98-4.28-9.83-4.43-6.81-.26-12.97 4.54-14.37 11.11-1.43 6.72 1.97 13.46 8.12 16.08 6.44 2.74 14.14.43 18.05-5.48-1.02-1.55-2.05-3.12-3.2-4.86-.84.96-1.5 1.84-2.28 2.59-.83.79-1.7 1.58-2.67 2.16-3.16 1.9-7.21 1.44-9.96-1.01-2.73-2.44-3.57-6.59-2.02-9.98 1.54-3.38 5.05-5.35 8.69-5.01 3.72.35 6 2.74 7.95 5.52s3.59 5.79 5.65 8.48c1.7 2.22 3.58 4.43 5.79 6.09 4.66 3.5 10.96 3.49 15.75.41Z",
    style: {
      fill: "url(#boomAI_icon_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.67 59.35c-2.07 2.07-5.44 2.07-7.53 0-.94-.94-2.58-.94-3.52 0-.97.97-.97 2.55 0 3.52 1.92 1.94 4.51 3.02 7.29 3.02s5.36-1.07 7.28-3.01c.97-.97.97-2.55 0-3.52s-2.58-.94-3.52 0Z",
    style: {
      fill: "url(#boomAI_icon_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.77 91.35-3.49-1.37a4.82 4.82 0 0 1-2.73-2.73l-1.37-3.46a.4.4 0 0 0-.22-.22c-.2-.08-.42.02-.5.22l-1.37 3.46a4.82 4.82 0 0 1-2.73 2.73l-3.46 1.37c-.1.04-.18.12-.22.22-.08.2.02.42.22.5l3.46 1.37c1.25.49 2.24 1.48 2.73 2.73l1.37 3.46c.04.1.12.18.22.22.2.08.42-.02.5-.22l1.37-3.46a4.82 4.82 0 0 1 2.73-2.73l3.49-1.37c.1-.04.18-.12.22-.22.08-.2-.02-.42-.22-.5",
    style: {
      fill: "url(#boomAI_icon_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.81 70.97h-2.83c-16.85 0-30.51-13.66-30.51-30.51V31.1c0-4.09 3.32-7.41 7.41-7.41H67.1c4.09 0 7.41 3.32 7.41 7.41v10.01c0 2.28-.28 4.54-.83 6.75-.3 1.18.37 2.39 1.53 2.77l3.48 1.14c1.21.4 2.52-.25 2.92-1.47.02-.05.03-.1.04-.15.75-2.95 1.14-5.99 1.14-9.04V31.1c0-8.67-7.03-15.69-15.7-15.7h-7.53v-3.66c2.4-.8 4.13-3.05 4.13-5.72a6.03 6.03 0 0 0-12.06 0c0 2.67 1.73 4.92 4.13 5.72v3.66h-8.63v-.09h-8.29v.09h-7.66v-3.66c2.4-.8 4.13-3.05 4.13-5.72a6.03 6.03 0 0 0-12.06 0c0 2.67 1.73 4.92 4.13 5.72v3.66h-8.5c-8.67 0-15.69 7.03-15.7 15.7v9.36c0 21.43 17.37 38.81 38.81 38.81h2.83c1.28 0 2.32-1.04 2.32-2.32V73.3c0-1.28-1.04-2.32-2.32-2.32Z",
    style: {
      fill: "url(#boomAI_icon_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.07 40.54c-1.23 0-2.27-.73-2.75-1.78a6.03 6.03 0 1 0 3.98-3.98c1.05.47 1.78 1.52 1.78 2.75 0 1.67-1.35 3.01-3.01 3.01",
    style: {
      fill: "url(#boomAI_icon_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.65 40.54c-1.22 0-2.27-.73-2.75-1.78a6.03 6.03 0 1 0 3.98-3.98c1.05.47 1.78 1.52 1.78 2.75 0 1.67-1.35 3.01-3.01 3.01",
    style: {
      fill: "url(#boomAI_icon_svg2__g)"
    }
  }));
};
export default SvgBoomAiIcon;